import './Top.css'
import img from '../../../assets/world_logo.png'
import { Link } from 'react-router-dom'
import line from '../../../assets/line-footer-top.png'


export default () => {
    return (
        <nav>
            <img className='supergraphic' src={line} />
            <div className="nav-main">
                <div className='brand'>
                    <Link to="/"><img src={img} className='img-logo' alt="Image with the logo project" /></Link>
                </div>

            </div>
        </nav>
    )

} 